type QueryValue = string | number | boolean | undefined | null;

export function buildApiPathWithQuery(path: string, params: Record<string, QueryValue> | object = {}): string {
  const search = new URLSearchParams();
  Object.entries(params as Record<string, QueryValue>).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, String(value));
    }
  });
  const q = search.toString();
  return `${path}${q ? `?${q}` : ''}`;
}
